import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
    getTrainers, 
    addTrainer, 
    updateTrainer, 
    deleteTrainer, 
    getTrainerById,
    clearError,
    clearSelectedTrainer,
    setSelectedTrainer
} from '../store/slices/trainersSlice';

const useTrainers = () => {
    const dispatch = useDispatch();
    const { trainers, selectedTrainer, loading, error } = useSelector(state => state.trainers);

    const fetchTrainers = () => {
        dispatch(getTrainers());
    };

    const createTrainer = (trainerData) => {
        return dispatch(addTrainer(trainerData));
    };

    const editTrainer = (trainerData) => {
        return dispatch(updateTrainer(trainerData));
    };

    const removeTrainer = (id) => {
        return dispatch(deleteTrainer(id));
    };

    const fetchTrainerById = (id) => {
        dispatch(getTrainerById(id));
    };

    const clearTrainerError = () => {
        dispatch(clearError());
    };

    const clearSelectedTrainerData = () => {
        dispatch(clearSelectedTrainer());
    };

    const selectTrainer = (trainer) => {
        dispatch(setSelectedTrainer(trainer));
    };

    return {
        trainers,
        selectedTrainer,
        loading,
        error,
        fetchTrainers,
        createTrainer,
        editTrainer,
        removeTrainer,
        fetchTrainerById,
        clearTrainerError,
        clearSelectedTrainerData,
        selectTrainer
    };
};

export default useTrainers; 